import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ColorMode = 'light' | 'dark';

interface UiState {
  colorMode: ColorMode;
  sidebarCollapsed: boolean;
  setColorMode: (mode: ColorMode) => void;
  toggleColorMode: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      colorMode: 'light',
      sidebarCollapsed: false,
      setColorMode: (colorMode) => set({ colorMode }),
      toggleColorMode: () =>
        set((state) => ({ colorMode: state.colorMode === 'light' ? 'dark' : 'light' })),
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
    }),
    { name: 'crm-ui-preferences-v1' },
  ),
);
